module.exports = __webpack_public_path__ + "img/CB34-On-1.02434d46.gif";